import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { AuthService, RestServices } from '../../services'
import { emailValidator, validateAllFormFields } from '../../../models'
import { BehaviorSubject } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['../promotion.component.css', './forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {

    en = {}
    showEN = true
    isConfirmed = false
    str: any
    formGroup: FormGroup
    statusSubmit = false
    completeStatus: boolean

    checkMailMxObservable = new BehaviorSubject<string>(null)
    hasErrorServer: boolean

    constructor(private auth: AuthService, private formBuider: FormBuilder, private checkFormat: RestServices) {
        this.validatorForm()
        this.checkMailMxObservable.pipe(debounceTime(300), distinctUntilChanged()).subscribe(email => {
            if (email) {
                this.checkFormat.http_post('form/checkMx', { host: email }).subscribe(
                    response => {
                        this.str = response['status']
                    },
                )
            }
        })
    }

    ngOnInit() {
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

    validatorForm() {
        this.formGroup = this.formBuider.group({
            email: ['', [Validators.required, emailValidator()]],
            organization: ['', [Validators.required]],
            user: ['', [Validators.required]],
        })
    }

    // check format email server
    checkFormatEmail() {
        const format = this.formGroup.value.email.slice(this.formGroup.value.email.search('@') + 1)

        this.checkMailMxObservable.next(format)
    }

    // message valid
    isFieldValid(field: string) {
        if (this.statusSubmit === true) {
            return !this.formGroup.get(field).valid && this.formGroup.get(field).touched
        } else {
            return this.formGroup.get(field).dirty && (this.formGroup.get(field).status === 'INVALID')
        }
    }

    // message css
    displayFieldCss(field: string) {
        return {
            'has-error': this.isFieldValid(field),
        }
    }

    // submit
    onSubmit() {
        if (this.formGroup.valid) {
            // send request to server to validate exists
            const body = this.getRequestData()
            this.hasErrorServer = false
            this.checkFormat.http_post('account/forgot-password-validate', body).subscribe(
                (result: any) => {
                    if (result.error) {
                        this.hasErrorServer = true
                    } else {
                        this.isConfirmed = true
                    }
                },
            )

        } else {
            validateAllFormFields(this.formGroup)
            this.statusSubmit = true
        }
    }

    // submit isConfirmed
    submitApply() {
        if (this.isConfirmed) {
            const body = this.getRequestData()
            this.checkFormat.http_post('account/forgot-password', body).subscribe(
                (result: any) => {
                    if (result.error) {
                        this.hasErrorServer = true
                    } else {
                        this.completeStatus = true
                    }
                },
            )
        }
    }

    getRequestData() {
        const lang = (localStorage.getItem('lang') === 'true') ? 'en' : 'ja'

        return {
            email: this.formGroup.value.email,
            organizationId: this.formGroup.value.organization,
            userId: this.formGroup.value.user,
            lang: lang,
        }
    }

    // back form
    reset() {
        this.isConfirmed = false
        this.completeStatus = false
        this.hasErrorServer = false
    }
}



// WEBPACK FOOTER //
// ./src/app/promotion/forgot-password/forgot-password.component.ts